var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8472 9.41194L9.61633 7.73881V4.33062C9.61633 3.98794 9.33933 3.71094 8.99664 3.71094C8.65395 3.71094 8.37695 3.98794 8.37695 4.33062V8.04869C8.37695 8.24388 8.46867 8.42794 8.62483 8.54444L11.1035 10.4035C11.2151 10.4871 11.3452 10.5274 11.4747 10.5274C11.6637 10.5274 11.8496 10.4425 11.9711 10.2789C12.1769 10.0056 12.1211 9.61706 11.8472 9.41194Z",
    fill: "#AAB8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99805 0C4.58658 0 0.998047 3.58853 0.998047 8C0.998047 12.4115 4.58658 16 8.99805 16C13.4095 16 16.998 12.4115 16.998 8C16.998 3.58853 13.4095 0 8.99805 0ZM8.99805 14.7607C5.2707 14.7607 2.23739 11.7273 2.23739 8C2.23739 4.27266 5.2707 1.23934 8.99805 1.23934C12.726 1.23934 15.7587 4.27266 15.7587 8C15.7587 11.7273 12.7254 14.7607 8.99805 14.7607Z",
    fill: "#AAB8D1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.998047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ed56ee870265a633fc2446467ccf3cc3.svg";
export { ForwardRef as ReactComponent };